import { CompanyModule } from '../common/enums/companyModule.enum'
import { ICompany } from '../common/models/Company'
import { isModuleEnabled as isSettingsModuleEnabled } from '../common/helpers/moduleAccess.helper'
import { useAppState } from '../context/AppContext'

// Company-level convenience wrapper around the shared settings helper (single
// source of the "absent = enabled" semantic). Kept for navHelper/requestsHelper.
export const isModuleEnabled = (
  company: ICompany | undefined,
  module: CompanyModule
): boolean => isSettingsModuleEnabled(company?.settings, module)

export const useModuleAccess = () => {
  const { company } = useAppState()

  return {
    employerBranding: isModuleEnabled(company, CompanyModule.EMPLOYER_BRANDING),
    onboarding: isModuleEnabled(company, CompanyModule.ONBOARDING),
    performanceManagement: isModuleEnabled(
      company,
      CompanyModule.PERFORMANCE_MANAGEMENT
    ),
    isModuleEnabled: (module: CompanyModule) =>
      isModuleEnabled(company, module),
  }
}
